// extracted by mini-css-extract-plugin
module.exports = {"tabRow":"PreviewConfig_tabRow__1Dblu","loaderAnimation":"PreviewConfig_loaderAnimation__2vdTf","helpLink":"PreviewConfig_helpLink__1777N"};